/* ----------------------------------------
    Store
---------------------------------------- */

import store from '@store/store';

/* ----------------------------------------
    Modules
---------------------------------------- */

export class StoreModule {

    /* ----------------------------------------
        Constructor
    ---------------------------------------- */

    protected constructor(module) {
        this._module = module;
    }

    /* ----------------------------------------
        Slugs
    ---------------------------------------- */

    slug(title) {
        return title.toLowerCase().replace(/[^\w ]+/g,'').replace(/ +/g,'-');
    }

    /* ----------------------------------------
        Getters
    ---------------------------------------- */

    getters(name, param) {
        const get = store.getters;
        return param ? get[this._module + '/' + name](param) : get[this._module + '/' + name];
    }

    /* ----------------------------------------
       Mutations
   ---------------------------------------- */

    actions(name, param) {
        const action = store.dispatch;
        return param ? action(this._module + '/' + name, param) : action(this._module + '/' + name);
    }

}